import * as XLSX from 'xlsx';

export function exportToExcel(filename, rows, sheetName = 'Data') {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename + '.xlsx');
}

export function exportToCsv(filename, rows) {
  if (!rows.length) return;
  const keys = Object.keys(rows[0]);
  const csv = [
    keys.join(','),
    ...rows.map((row) => keys.map((k) => `"${String(row[k] ?? '').replace(/"/g, '""')}"`).join(','))
  ].join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename + '.csv';
  a.click();
  URL.revokeObjectURL(url);
}

export function exportOrdersData(orders, dateLabel, money, orderStatus, orderStudent, orderPhone, orderTotal, totalUnits) {
  return orders.map((o) => ({
    'Order ID': o.orderId || o.id,
    'Payment ID': o.paymentId || '',
    'Date': dateLabel(o.createdAt),
    'Student': orderStudent(o),
    'Phone': orderPhone(o),
    'Total': orderTotal(o),
    'Status': orderStatus(o),
    'Items': (o.items || []).map((i) => `${i.bt || i.bookTitle} ${i.vn || i.variantName} x${i.qty}`).join(' | '),
    'Address': o.delivery?.address || '',
    'Type': o.isManual ? 'Manual' : 'Online'
  }));
}

export function exportStudentsData(students) {
  return students.map((s) => ({
    'Name': s.name || '',
    'Phone': s.phone || s.id || '',
    'Email': s.email || '',
    'Street': s.street || '',
    'District': s.district || '',
    'State': s.state || '',
    'Pincode': s.pincode || '',
    'Alt Phone': s.altPhone || '',
    'DOB': s.dob || '',
    'Source': s.source || '',
    'Address': s.address || ''
  }));
}
